import { getCurrentOrg } from "./storage";

// Which site this DEVICE is working at, per org. It's a property of where the
// phone or tablet physically sits, not of the person signed in, so it lives
// on the device and survives worker sign-in/out. Storage can be unavailable
// (private mode) — then we simply send no site, same as a single-site org.
const key = (orgId: number) => `trim.${orgId}.siteId`;

export function getDeviceSite(): number | null {
  const orgId = getCurrentOrg();
  if (orgId === null) return null;
  try {
    const v = Number(localStorage.getItem(key(orgId)));
    return Number.isInteger(v) && v > 0 ? v : null;
  } catch {
    return null;
  }
}

export function setDeviceSite(siteId: number | null): void {
  const orgId = getCurrentOrg();
  if (orgId === null) return;
  try {
    if (siteId === null) localStorage.removeItem(key(orgId));
    else localStorage.setItem(key(orgId), String(siteId));
  } catch {
    /* storage unavailable — the run just goes untagged */
  }
}
